type ResourceItem = { id: string; name: string; quantity: number };

export type WorkforceContractorGroup = {
  id: number;
  name: string;
  workforces: ResourceItem[];
};

export type EquipmentContractorGroup = {
  id: number;
  name: string;
  equipments: ResourceItem[];
};

type RawResourceItem = {
  contractor_id: number;
  contractor_name: string;
  trade_id: number;
  trade_name: string;
  quantity: number;
};

export function groupWorkforceItemsByContractor(workforceItems: RawResourceItem[]): WorkforceContractorGroup[] {
  const map = new Map<number, WorkforceContractorGroup>();

  for (const item of workforceItems) {
    if (!map.has(item.contractor_id)) {
      map.set(item.contractor_id, {
        id: item.contractor_id,
        name: item.contractor_name,
        workforces: [],
      });
    }
    map.get(item.contractor_id)?.workforces.push({
      id: String(item.trade_id),
      name: item.trade_name,
      quantity: item.quantity,
    });
  }

  return Array.from(map.values());
}

export function groupEquipmentItemsByContractor(equipmentItems: RawResourceItem[]): EquipmentContractorGroup[] {
  const map = new Map<number, EquipmentContractorGroup>();

  for (const item of equipmentItems) {
    if (!map.has(item.contractor_id)) {
      map.set(item.contractor_id, {
        id: item.contractor_id,
        name: item.contractor_name,
        equipments: [],
      });
    }
    map.get(item.contractor_id)?.equipments.push({
      id: String(item.trade_id),
      name: item.trade_name,
      quantity: item.quantity,
    });
  }

  return Array.from(map.values());
}
